import cramsheets from "@/public/static/icons/resources/cramsheeticon.svg";
import definitions from "@/public/static/icons/resources/definitionicon.svg";
import flashcards from "@/public/static/icons/resources/flashcardicon.svg";
import iaexamples from "@/public/static/icons/resources/iaexampleicon.svg";
import mockexams from "@/public/static/icons/resources/mockexamicon.svg";
import notes from "@/public/static/icons/resources/noteicon.svg";
import questions from "@/public/static/icons/resources/questionicon.svg";
import syllabus from "@/public/static/icons/resources/syllabusicon.svg";
import testbuilder from "@/public/static/icons/resources/testbuildericon.svg";
import tests from "@/public/static/icons/resources/topictesticon.svg";
import videos from "@/public/static/icons/resources/videoicon.svg";

import { SelectedAccountType } from "../types";

export type AccountTypePreviewItem = {
  title: string;
  description: string;
  Icon: any;
  activeFor: SelectedAccountType[];
};

export const accountTypePreviewMeta: {
  resources: AccountTypePreviewItem[];
  features: AccountTypePreviewItem[];
} = {
  resources: [
    {
      title: "Videos",
      description: "Concise animated videos; key for understanding",
      Icon: videos,
      activeFor: ["Member", "Trial"],
    },
    {
      title: "Notes",
      description: "Clear revision notes; key for learning",
      Icon: notes,
      activeFor: ["Member", "Trial"],
    },
    {
      title: "Flashcards",
      description: "Over 3,700 flashcards; key for memorising",
      Icon: flashcards,
      activeFor: ["Member", "Trial"],
    },
    {
      title: "Questions & Mark schemes",
      description: "Over 5,300 questions with answers; key for practice",
      Icon: questions,
      activeFor: ["Member", "Trial"],
    },
    {
      title: "Cram Sheets",
      description: "Condensed sub-topic sheets; key for quick reviews",
      Icon: cramsheets,
      activeFor: ["Member"],
    },
    {
      title: "Topic Tests",
      description: "Exam-timed topic tests; key for exam prep",
      Icon: tests,
      activeFor: ["Member", "Trial"],
    },
    {
      title: "More...",
      description: "Definitions, example IAs, Command Terms, and exam criteria",
      Icon: definitions,
      activeFor: ["Basic", "Member", "Trial"],
    },
  ],
  features: [
    {
      title: "Progress Tracker",
      description:
        "Integrated site-wide performance metrics; key for improving",
      Icon: iaexamples,
      activeFor: ["Member", "Trial"],
    },
    {
      title: "Mock Exams",
      description: "IB-style mock exams; key for exam prep",
      Icon: mockexams,
      activeFor: ["Member", "Trial"],
    },
    {
      title: "Custom Test Builder",
      description: "Fully customisable tests; key for targeting weaknesses",
      Icon: testbuilder,
      activeFor: ["Member", "Trial"],
    },
    {
      title: "Syllabus Checklist",
      description: "Interactive syllabus checklist; key for organisation",
      Icon: syllabus,
      activeFor: ["Member", "Trial"],
    },
  ],
};
